module.exports = __webpack_public_path__ + "img/catch01.e464bf66.png";